export default __webpack_public_path__ + "static/media/img6.3ee96916.jpg";